import CryptoJS from 'crypto-js';
import VueElementLoading from "vue-element-loading";
// import PrintRequest from "../PrintRequest/index.vue";
// import Test from '../RVPPrintLabelv2/index.vue';
import { updateShipmentStatusForOnePager,getRvpProductDetails } from "../../../../services/modules/printlabelservices.js";

export default {
    name: "ReverseShipmentDetails",
    components: {
        VueElementLoading,
        // 'PrintRequestComponent': PrintRequest,
        // 'Test': Test,
    },
    props: {
        propsParam: String  // Define the type of the prop
    },
    data() {
        return {
            shippingId: '',
            isProductDetailsTableLoading: true,
            showProductDetailsTable: true,
            isImagesAvailable: false,
            isPopupVisible: false,
            popupImageUrl: "",
            popupImageIndex: 0,
            currentImageSet: [],
            productsArr: [],
            showDetails: true,
            screen: '3',

            /* Hundle Error */
            errors:"",
            iserrors:false,
            srid:'',
            srname:'',
            hubid:'',
            localuserid:'',
            ishubexecutive:[],
            userid:'',
            username:'',
            userrole:'',
            userDataKey:''
            

        };
    },
    async mounted() {

        

        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userrole = userdetail.userrole[0].rolename;
        this.username = userdetail.username;
        this.userid = userdetail.userid;
        this.ishubexecutive = userdetail.userrole
            .map(role => role.rolename.trim().toLowerCase() === "admin") //hub_executive
            .includes(true); // Check if any role matches
        this.localuserid = userdetail.userid
        this.hubid = userdetail.hubdetails[0];

        if (this.propsParam && this.propsParam.shipmentDetails && this.propsParam.shipmentDetails.ShippingId) {
            this.shippingId = this.propsParam.shipmentDetails.ShippingId
            this.shippingType = this.propsParam.shipmentDetails.shipmentType
            await this.fetchProductDetails();
        } else {
            this.errors="Shipping Id Required";
            this.iserrors=true;
            // this.$alertify.error("Shipping Id Required");
            return
        }

    },
    methods: {
        async fetchProductDetails() {

            if (!this.shippingId.trim()) {
                this.errors="Shipping Id Required";
                this.iserrors=true;
                // this.$alertify.success("Shipping ID is required.");
                return;
            }
            this.resetError();

            this.isProductDetailsTableLoading = true;
            try {
                const reqPayload = { shippingId: this.shippingId.trim(), "requestedBy":this.username };

                await getRvpProductDetails(reqPayload,(result)=>{
                    
                    if (result.data.code === 200) {
                        this.srid = result.data.data.srid;
                        this.srname = result.data.data.srname;
                        this.productsArr = result.data.data.ProductDetails || [];
                        // Check if any product has images
                        this.isImagesAvailable = this.productsArr.some(
                            (product) => product.PickupProductImage || product.SRPickDoneImages
                        );

                        // handled condtion nonqcrvptype == closedbox reload this page
                        let hasCloseBox = this.productsArr.some(shipment => shipment.nonqcrvptype === 'ClosedBox');
                        if (hasCloseBox) {
                            this.handleApprove(hasCloseBox)
                        }else{
                            this.isProductDetailsTableLoading = false;
                            this.showProductDetailsTable = true;
                        }
                    }
                    else {
                        this.isProductDetailsTableLoading = false;
                        this.errors = result.data.message;
                        this.iserrors = true;
                        //this.$alertify.success(response.message);
                    }
                });
            } catch (error) {
                this.isProductDetailsTableLoading = false;
                console.error("Failed to fetch product details:", error);
                this.$alertify.error("Failed to load product details. Please try again later.");
            }
        },
        showPopup(imageUrl, imagesArray, index) {
            this.popupImageUrl = imageUrl;
            this.popupImageIndex = index;
            this.currentImageSet = imagesArray;
            this.isPopupVisible = true;
        },
        closePopup() {
            this.isPopupVisible = false;
            this.popupImageUrl = "";
            this.popupImageIndex = 0;
            this.currentImageSet = [];
        },
        showPreviousImage() {
            if (this.popupImageIndex > 0) {
                this.popupImageIndex--;
                this.popupImageUrl = this.currentImageSet[this.popupImageIndex].ImageUrl;
            }
        },
        showNextImage() {
            if (this.popupImageIndex < this.currentImageSet.length - 1) {
                this.popupImageIndex++;
                this.popupImageUrl = this.currentImageSet[this.popupImageIndex].ImageUrl;
            }
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        async handleApprove(hasCloseBox = false) {
            /* Calling Update API Here */
            let RequestForNewPrint = {
                "hubid": this.hubid,
                "requestedby": this.userid,
                "requestsource": "lm",
                "shippingid": this.shippingId.toString(),
                "shipmenttype": this.propsParam.shipmentDetails.shipmentType,
                "centertype": this.propsParam.shipmentDetails.centerType,
                "istlqceligible": this.propsParam.shipmentDetails.isTlqcShipment,
                "istlqcdone": this.propsParam.shipmentDetails.hasTlqcProcessCompleted,
                "userrole": this.userrole.toString(),
                "action": "reviewdone",
                "hasCloseBox":(hasCloseBox) ? hasCloseBox: false,
              }
              updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                try {
                  /* reset All Fields */
                  if (result.data.code == 200) {
                    this.$alertify.success(result.data.message);
                    setTimeout(() => {
                        this.isProductDetailsTableLoading = false;
                        window.location.reload();
                      }, 2000); // 10000 milliseconds = 10 seconds
                  } else {
                    this.$alertify.error(result.message);
                  }
                } catch (error) {
                  console.log('result------', error.message);
                }
              })
        },
        async handleReject() {
            /* Calling Update API Here */
            let RequestForNewPrint = {
                "hubid": this.hubid,
                "requestedby": this.userid,
                "requestsource": "lm",
                "shippingid": this.shippingId.toString(),
                "shipmenttype": this.propsParam.shipmentDetails.shipmentType,
                "centertype": this.propsParam.shipmentDetails.centerType,
                "istlqceligible": this.propsParam.shipmentDetails.isTlqcShipment,
                "istlqcdone": this.propsParam.shipmentDetails.hasTlqcProcessCompleted,
                "userrole": this.userrole.toString(),
                "action": "reviewfailed"
              }
              updateShipmentStatusForOnePager(RequestForNewPrint, (result) => {
                try {
                  /* reset All Fields */
                  if (result.data.code == 200) {
                    this.$alertify.success(result.data.message);
                   
                    setTimeout(() => {
                        window.location.reload();
                      }, 2000); // 10000 milliseconds = 10 seconds
                  } else {
                    this.$alertify.error(result.message);
                  }
                } catch (error) {
                  console.log('result------', error.message);
                }
              })
        },
        resetError(){
            this.iserrors = false;
            this.errors=''
        },
        reset() {
            this.shippingId = ''
            this.isProductDetailsTableLoading = false
            this.showProductDetailsTable = false
            this.isImagesAvailable = false
            this.isPopupVisible = false
            this.popupImageUrl = ''
            this.popupImageIndex = 0
            this.currentImageSet = []
            this.productsArr = []
            this.showDetails = true
        }
    },
};



// WEBPACK FOOTER //
// ./src/views/components/RVPPrintLabelReviewv2/RVPPrintLabelReviewv2.component.js